import React from 'react'
import PropTypes from 'prop-types'

import { Button, LazyImage } from '@offerzen/pinata-shame'

import styles from './styles'

const EmptySection = ({ svgName, buttonAction, buttonLabel, hideButton, theme, svgWidth, children }) => (
  <div className={styles.wrapper}>
    <LazyImage loader={() => import(`../../../assets/${svgName}.svg`)} width={svgWidth} alt={svgName} />

    <div className={styles.text}>{children}</div>

    <If condition={!hideButton}>
      <Button label={buttonLabel} theme={theme} variant="outlined" onClick={buttonAction} />
    </If>
  </div>
)

EmptySection.defaultProps = {
  hideButton: false,
}

EmptySection.propTypes = {
  svgName: PropTypes.string,
  buttonAction: PropTypes.func,
  buttonLabel: PropTypes.string,
  hideButton: PropTypes.bool,
  theme: PropTypes.string,
  svgWidth: PropTypes.number,
  children: PropTypes.node,
}

export default EmptySection
